import { OportunidadProductos } from "../shared/response/ventas/OportunidadResponse";

/** Id de un producto del Pipeline: las claves de `OportunidadProductos` y del catálogo de servicios del Server. */
export type ProductoId = "dataag" | "rastro" | "bascula" | "vista" | "protec";

const PRODUCTOS_SEXTANTE: readonly ProductoId[] = ["dataag", "rastro", "bascula", "vista", "protec"];

// Sin VISTA ni PROTEC (2026-10-20). RASTRO y Báscula siguen mientras se valida cómo se ajustan: Nitrofert va a tener
// hardware.
const PRODUCTOS_NITROFERT: readonly ProductoId[] = ["dataag", "rastro", "bascula"];

/**
 * Productos que vende la marca (decisión del usuario, 2026-10-20). Precios, el Pipeline (ventana de oportunidad,
 * cotización y su PDF, ficha, Kanban y Lista) y Promotores muestran, cotizan y suman solo estos. Para cambiar lo que
 * vende una marca alcanza con sus listas de arriba.
 *
 * DATA AG lo venden las dos marcas y la cotización lo da por hecho (las fincas que se cargan ahí son para su precio): la
 * lista decide sobre RASTRO, Báscula, VISTA y PROTEC.
 *
 * Solo filtra la web: el Server sigue sirviendo las cinco tarifas y el catálogo completo de servicios. Pendiente de
 * validar en Nitrofert: RASTRO y Báscula (`docs/pendientes.md` del Server).
 */
export class ProductosMarca {
  private readonly _ids: ReadonlySet<string>;

  /** Productos de Sextante o de Nitrofert. */
  constructor(isSextante: boolean) {
    this._ids = new Set<string>(isSextante ? PRODUCTOS_SEXTANTE : PRODUCTOS_NITROFERT);
  }

  /** Si la marca vende el producto. Recibe `string` porque el catálogo del Server trae los ids como texto. */
  ofrece(id: string): boolean {
    return this._ids.has(id);
  }

  /**
   * Los productos de una oportunidad sin los que la marca no vende. Una oportunidad guardada antes de que se ocultaran
   * puede traerlos marcados: así no se muestran ni se cotizan, y si la oportunidad se vuelve a guardar quedan
   * desmarcados.
   */
  filtrar(p: OportunidadProductos): OportunidadProductos {
    return {
      dataag: p.dataag,
      rastro: this.ofrece("rastro") ? p.rastro : 0,
      bascula: this.ofrece("bascula") ? p.bascula : 0,
      vista: this.ofrece("vista") && p.vista,
      protec: this.ofrece("protec") && p.protec ? { ...p.protec } : { activo: false, cat: "", ha: 0 },
    };
  }
}
